import { log } from 'console';
import React, { useRef, useEffect, useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


type SponsorshipmoduleProps = {
    sponsorshipLogo: any,
    sponsorshipText: any,
    sponsorshipHyperlink: any,
    sponsorship_logo_height:any,
};
export default function Sponsorshipmodule({
    sponsorshipLogo,
    sponsorshipText,
    sponsorshipHyperlink,
    sponsorship_logo_height,
}: SponsorshipmoduleProps) {

    const baseURL = "https://newsword.ai/member-area/public/";
    const imgPath = `${baseURL}${sponsorshipLogo}`;

    const elementRef = useRef<HTMLDivElement | null>(null);


    return (

         <div className='sponsorship-module' style={{ borderTop: 'none' }}>
             <div className='sponsorship-module-inner mx-width'>
                 <a href={sponsorshipHyperlink} target="_blank" rel="noopener noreferrer" className='hyperlink' style={sponsorshipText ? {} : { marginLeft: 0, marginRight: 0 }}>
                    {/* style={{ width: '100%', maxWidth: '40px', }} */}
                     <span >
                        <img
                            style={{ height: sponsorship_logo_height ? `${sponsorship_logo_height}px` : '40px' , maxWidth:'unset' , width: sponsorshipText ? '' : '100%', }} src={imgPath} alt="" />

                        {/* className='sponsorship-module-logo' */}
                        </span>
                        {sponsorshipText ? <span className='sponsorship-text'>{sponsorshipText}</span> : 
                        ''
                        }
                    
                     
                 </a>
             </div>
         </div>
       



    );
}
